export default __webpack_public_path__ + "static/media/consultImage.04f4393d.svg";